export function getOSName(userAgent) {
  const osPatterns = [
    [/Windows NT 10\.0/, 'Windows 10/11'],
    [/Windows NT 6\.3/, 'Windows 8.1'],
    [/Windows NT 6\.2/, 'Windows 8'],
    [/Windows NT 6\.1/, 'Windows 7'],
    [/Windows NT 6\.0/, 'Windows Vista'],
    [/Windows NT 5\.1/, 'Windows XP'],
    [/Macintosh/, 'macOS'],
    [/iPhone/, 'iPhone'],
    [/iPad/, 'iPad'],
    [/iPod/, 'iPod'],
    [/Android/, 'Android'],
    [/Ubuntu/, 'Ubuntu'],
    [/Linux/, 'Linux'],
  ];

  const match = osPatterns.find(([regex]) => regex.test(userAgent));
  return match ? match[1] : 'Unknown OS';
}

export function parseDuration(durationStr) {
  if (!durationStr || typeof durationStr !== 'string') return 0;
  const [h, m, s] = durationStr
    .replace(/h|m|s/g, '')
    .split(' ')
    .map((n) => Number(n) || 0);
  return h * 3600 + m * 60 + s;
}
